import React, { useState } from 'react';
import { Linkedin, Twitter, Link2, Check } from 'lucide-react';

export default function ShareBar({ url, text, testid = 'share', className = 'mt-6' }) {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try { await navigator.clipboard.writeText(url); } catch (e) { window.prompt('Copy this link', url); }
    setCopied(true); setTimeout(() => setCopied(false), 2000);
  };
  const btn = 'inline-flex items-center gap-2 border border-[#111111]/20 font-medium px-5 py-3 rounded-full hover:bg-[#f4f4f4] transition-colors text-sm';
  return (
    <div className={`flex flex-wrap gap-3 ${className}`} data-testid={`${testid}-bar`}>
      <a className={btn} target="_blank" rel="noopener noreferrer" data-testid={`${testid}-linkedin`}
        href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`}><Linkedin size={16} /> Share on LinkedIn</a>
      <a className={btn} target="_blank" rel="noopener noreferrer" data-testid={`${testid}-x`}
        href={`https://x.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`}><Twitter size={16} /> Share on X</a>
      <button className={btn} onClick={copy} data-testid={`${testid}-copy`}>{copied ? <Check size={16} /> : <Link2 size={16} />} {copied ? 'Link copied' : 'Copy link'}</button>
    </div>
  );
}
